import React, { useEffect, useMemo, useState } from 'react';
import Separator from '../../../../../components/Separator/Separator';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import CustomRadioGroup from '../../../../../components/CustomRadioGroup/CustomRadioGroup';

const EyeCooperativeWorkCheck = ({ data, control, setValue }) => {
  const { t } = useTranslation();
  const [bValue, setBValue] = useState(data?.eyeCooperativeWorkCheck?.b);

  const values = useMemo(
    () => [
      {
        label: t('yes'),
        checked: bValue === true,
        value: true,
      },
      {
        label: t('no'),
        checked: bValue === false,
        value: false,
      },
    ],
    [bValue]
  );


  useEffect(() => {
    setValue('eyeCooperativeWorkCheck.b', data?.eyeCooperativeWorkCheck?.b);
  }, []);

  return (
    <>
      <Separator text={t('examinations:screenings.eyeCooperativeWorkCheck.title')} hint={t('examinations:screenings.eyeCooperativeWorkCheck.hint')}/>
      <Row>
        <Col md={6}>
          <h5>{t('examinations:bothEyes')}</h5>
          <CustomRadioGroup
            label={t('examinations:screenings.eyeCooperativeWorkCheck.withoutEyeSlant')}
            labelClass="d-block"
            items={values}
            groupProps={{ className: 'mb-3' }}
            controlProps={{
              name: 'eyeCooperativeWorkCheck.b',
              control,
              rules: { validate: v => v !== undefined || 'required' },
              defaultValue: data?.eyeCooperativeWorkCheck?.b,
            }}
            onChange={v => {
              setBValue(v);
              setValue('eyeCooperativeWorkCheck.b', v);
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default EyeCooperativeWorkCheck;
